module.exports = __webpack_public_path__ + "static/img/HeNan_Banner_autumn.28c6a27f.jpg";